import { asyncRouterMap, constantRouterMap } from '@/router/router.config'

/**
 * 过滤账户是否拥有某一个权限，并将菜单从加载列表移除
 *
 * @param permissionList
 * @param route
 * @returns {boolean}
 */
function hasPermission (permissionList, route) {
  if (route.meta.permission === true) return true

  const target = permissionList.find(item => item.menuCode === route.path)
  if (target != null) {
    route.meta.menuId = target.menuId
    return true
  } else {
    return false
  }
}

function filterAsyncRouter (routerMap, permissionList) {
  const accessedRouters = routerMap.filter(route => {
    if (hasPermission(permissionList, route)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, permissionList)
      }
      return true
    }
    return false
  })
  return accessedRouters
}

function getPermissionList (permissibleMenuTree, list) {
  permissibleMenuTree.forEach(item => {
    list.push({
      menuCode: item.menuCode,
      menuId: item.id,
    })

    if (item.list != null && item.list.length > 0) {
      getPermissionList(item.list, list)
    }
  })

  return list
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: [],
    btnList: [],
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
    },
    changeBtnList (state, btnList) {
      state.btnList = btnList
    },
  },
  actions: {
    GenerateRoutes ({ commit }, permissibleMenuTree) {
      const permissibleMenuList = getPermissionList(permissibleMenuTree, [])

      return new Promise(resolve => {
        const accessedRouters = filterAsyncRouter(asyncRouterMap, permissibleMenuList)
        commit('SET_ROUTERS', accessedRouters)
        resolve()
      })
    }
  }
}

export default permission
